import axios from 'axios';

type FileUploadSubmissionSessionsResponseSubmissionSessionSubject = {
  category: 'IMAGE';
  id: string;
  formats: string[];
  forceResize: boolean;
  maxFileSizeConstraint: {
    maxFileSize: number;
    violationMessageTemplate: string;
  };
  maxWidthAndHeightConstraint: null;
};

type FileUploadSubmissionSessionsResponseSubmissionSession = {
  submissionId: string;
  library: {
    id: string;
    subjects: FileUploadSubmissionSessionsResponseSubmissionSessionSubject[];
  };
  accessKeyId: string;
  secretAccessKey: string;
  token: string;
  // Date
  expiration: string;
  mediaFileStore: {
    name: string;
    uploadPathMap: {
      file1: string;
    };
    propertyMap: {
      bucketName: string;
      region: string;
    };
  };
};

type FileUploadSubmissionSessionsResponse = {
  submissionSession: FileUploadSubmissionSessionsResponseSubmissionSession;
  mediaFormats: {
    name: string;
    categoryName: string;
    filenameExtensions: string[];
    mimeTypes: string[];
  }[];
};

export type FileUploadSubmissionSessionsResponseError = {
  errorMessage: string;
  errorType: string;
  stackTrace: string[];
};

const FILE_UPLOAD_SESSIONS_PATH = 'v1/sessions';
type GetFileUploadSubmissionSessionsPayload = {
  apiRoot: string;
  formSrn: string;
};
export const getFileUploadSubmissionSessions = async ({
  apiRoot,
  formSrn,
}: GetFileUploadSubmissionSessionsPayload): Promise<FileUploadSubmissionSessionsResponse> => {
  const url = `${apiRoot}${FILE_UPLOAD_SESSIONS_PATH}`;
  const sessions = await axios.post<FileUploadSubmissionSessionsResponse>(url, {
    libraryId: formSrn,
    submissionId: null,
  });
  return sessions.data;
};
